module.exports = __webpack_public_path__ + "img/message-text.e0240270.svg";